import { useQuery } from '@tanstack/react-query';
import { registration } from '@/api';
import { type RegistrationSetup, registrationSetupQueryKey } from '@/api/registration';
import { useTenantApi } from '@/account/hook/useTenantApi';

// We do not need to wrap every react query or mutations into hook. The reason why we do it here is because this query here will be used in a lot of components.
export function useRegistrationSetupsQuery(eventId: string) {
  // Load registration setup from the backend.
  const { createTenantAdminApiRequest, isLoading: isApiPreparing } =
    useTenantApi();
  return useQuery<RegistrationSetup, Error>({
    queryKey: [registrationSetupQueryKey, { eventId }],
    queryFn: async (): Promise<RegistrationSetup> => {
      const result = await registration.loadRegistrationSetup(
        createTenantAdminApiRequest
      )({ eventId });
      return result?.item;
    },
    enabled: !isApiPreparing
  });
}
